import React, { useState, useRef, useEffect } from "react";
import DataTable from "react-data-table-component";
import { DefaultImageBaseurl, endPoints } from "../../../constant/Environment";
import {
  addData,
  deleteData,
  getAllData,
  getAllFilterData,
} from "../../../Utility/API";
import { Modal, Form, Button } from "react-bootstrap";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Actions } from "../../../redux/Actions/Actions";
import Toaster from "../../../components/Toast";
import Loader from "../../../components/Loader";
import PageHeader from "../../../components/PageHeader";
import { ErrorToast, SuccesToast } from "../../../components/Toast/message";
import { AiTwotoneEyeInvisible, AiFillEyeInvisible } from "react-icons/ai";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import moment from "moment-timezone";
import IconButton from "@mui/material/IconButton";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";
import DeleteModel from "../../../components/DeleteModel";
import SearchIcon from "@mui/icons-material/Search";
import Switch from "@mui/material/Switch";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { uploadHeaders } from "../../../Utility/axiosInstances";

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

const Redemption = () => {
  const [editData, setEditData] = useState({});
  const [createData, setCreateData] = useState(false);
  const [rowDataToDelete, setRowDataToDelete] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [giftTitle, setGiftTitle] = useState("");
  const [sagaCoinPrice, setSagaCoinPrice] = useState("");
  const [creative, setCreative] = useState("");
  const [showcreative, setShowCreative] = useState("");
  const [startDate, setStartDate] = useState("");
  const [startTime, setStartTime] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [endTime, setEndTime] = useState(null);

  //campaignName

  const [campaignName, setCampaignName] = useState("");
  const [campaignId, setCampaignId] = useState("");

  const [currencyCode, setCurrencyCode] = useState(null);
  const [countryName, setCountryName] = useState(null);

  const [giftCopy, setgiftCopy] = useState(null);
  const [termConditions, setTermConditions] = useState(null);
  const [menuSort, setMenuSort] = useState(null);
  const [checkboxes, setCheckboxes] = useState({
    isCheckedActive: false,
    isCheckedFeatured: false,
  });
  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    setCheckboxes((prevCheckboxes) => ({
      ...prevCheckboxes,
      [name]: checked,
    }));
  };
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setCreative(file);
      setShowCreative(imageUrl);
      UploadImage(file);
    }
  };

  const UploadImage = (files) => {
    var formdata = new FormData();
    formdata.append("file", files);
    var requestOptions = {
      method: "POST",
      body: formdata,
      redirect: "follow",
      headers: uploadHeaders(),
    };
    setIsLoading(true);
    let imgUrl = `${endPoints.apiBaseUrl}${endPoints.api.UPLOAD_BANNER}`;
    fetch(imgUrl, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        setCreative(result.data);
        setIsLoading(false);
      })
      .catch((error) => console.log("error", error));
  };

  const [pending, setPending] = useState(true);
  const [show, setShow] = useState(false);
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleClose = () => setShow(false);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    // api call
    console.log('caledd useefct')
    giftList();
  }, []);

  const giftList = async () => {
    let url = `${endPoints.api.GET_GIFT}`;
    setIsLoading(true);
    await getAllData(url)
      .then((response) => {
        setIsLoading(false);
        if (response.status === "success") {
          setRows(response.data);
          setPending(false);
        } else {
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
      });
  };

  const handleOk = () => {
    if (
      giftTitle &&
      creative &&
      // startDate &&
      // startTime &&
      // endDate &&
      // endTime &&
      // giftCopy &&
      // termConditions 
      // &&
      menuSort
    ) {
      let url = editData?.id
        ? `${endPoints.api.UPDATE_GIFT}`
        : `${endPoints.api.ADD_GIFT}`;

      // const newStartDate = new Date(`${startDate}T${startTime}Z`).toISOString();
      // const newEndDate = new Date(`${endDate}T${endTime}Z`).toISOString();

      let payload = {
        gift_title: giftTitle,
        sagacoin_price: sagaCoinPrice,
        creative: creative,
        // startdate: newStartDate,
        // starttime: startDate,
        // enddate: newEndDate,
        // endtime: startDate,
        redemptionInstructions: giftCopy,
        termsAndConditions: termConditions,
        sort_order: menuSort,
        isactive: checkboxes.isCheckedActive ? 1 : 0,
        isfeatured: 0,
        countryName: countryName,
        currencyCode: currencyCode,
        campaignName:campaignName,
        productId:campaignId
      };

      if (editData?.id) {
        payload.id = editData.id;
      }
      setIsLoading(true);
      addData(url, payload)
        .then((response) => {
          setIsLoading(false);
          if (response.data.status === "success") {
            SuccesToast(response?.data?.message);
            giftList();
            console.log(response);
            handleClose();
          }
        })
        .catch((error) => {
          setIsLoading(false);
          console.error(error);
          ErrorToast(error);
        });
    } else {
      ErrorToast("all fields are required");
    }
  };

  useEffect(() => {
    if (editData) {
      //  console.log(editData)
      let imageFullPath =
        editData.creative !== undefined
          ?   editData.creative.includes("https:")  ?  editData.creative : `${endPoints.apiBaseUrl}${editData.creative}`
          : "";

      setGiftTitle(editData.gift_title || "");
      setSagaCoinPrice(editData.sagacoin_price || "");
      setCreative(editData.creative || "");
      setShowCreative(imageFullPath || "");
      setCurrencyCode(editData?.currencyCode || "");
      setCountryName(editData?.countryName || "");
      setCampaignName(editData?.campaignName || "");
      setCampaignId(editData?.productId || '')

      setStartDate(
        editData.startdate
          ? moment(editData.startdate).format("YYYY-MM-DD")
          : ""
      );
      setStartTime(
        editData.startdate ? moment.utc(editData.startdate).format("HH:mm") : ""
      );
      setEndDate(
        editData.enddate ? moment(editData.enddate).format("YYYY-MM-DD") : ""
      );
      setEndTime(
        editData.enddate ? moment.utc(editData.enddate).format("HH:mm") : ""
      );

      setgiftCopy(editData.redemptionInstructions || "");
      setTermConditions(editData.termsAndConditions || "");
      setMenuSort(editData.sort_order || "");
      setCheckboxes((prevCheckboxes) => ({
        ...prevCheckboxes,
        isCheckedFeatured: editData.isfeatured || false,
        isCheckedActive: editData.isactive || false,
      }));
    }
  }, [editData]);

  const handleDelete = (row) => {
    setRowDataToDelete(row);
    setShowDeleteModal(true);
  };

  const deleteRedemption = () => {
    const id = rowDataToDelete.id;

    let url = `${endPoints.api.DELETE_GIFT}${id}`;
    setIsLoading(false);
    deleteData(url)
      .then((response) => {
        console.log("update_Res", response);
        setIsLoading(false);
        if (response.status == 200) {
          setShowDeleteModal(false);
          giftList();
          SuccesToast("Deleted Successfully");
        } else {
        }
      })
      .catch((error) => {
        console.error(error);
        setIsLoading(false);
      });
  };

  const handleSwitchChange = (row, param, value) => {
    const updatedRow = { ...row, [param]: value === 0 ? 1 : 0 };
    updateRedemption(updatedRow);
  };

  const updateRedemption = (payload) => {
    const id = payload.id;
    let url = `${endPoints.api.UPDATE_GIFT}`;
    setIsLoading(true);
    addData(url, payload)
      .then((response) => {
        setIsLoading(false);
        if (response.data.status === "success") {
          SuccesToast(response?.data?.message);
          giftList();
          console.log(response);
          handleClose();
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
        ErrorToast(error);
      });
  };

  // Redemption Filter
  const [filteredRows, setFilteredRows] = useState(rows);
  const [filterValue, setFilterValue] = useState("");

  const handleFilterChange = (event) => {
    const newFilterValue = event.target.value.toLowerCase();
    setFilterValue(newFilterValue);

    if (newFilterValue === "") {
      setFilteredRows(rows);
    } else {
      const filteredData = rows.filter((item) =>
        item.gift_title.toLowerCase().includes(newFilterValue)
      );
      setFilteredRows(filteredData);
    }
  };

  const rowsToDisplay = filterValue.length > 0 ? filteredRows : rows;

  return (
    <>
      <div className="main">
        <Toaster></Toaster>
        <DeleteModel
          showModal={showDeleteModal}
          onClose={() => setShowDeleteModal(false)}
          onDelete={deleteRedemption}
        />
        {isLoading && <Loader spinner={true} visible={isLoading} />}
        <div id="Sportbook" style={{ padding: "0px" }}>
          <div className="container-fluid bg-color-sportbook custom-card4">
            <div className="inner-space1">
              <PageHeader title="Gift Card" crumb="Casino / Gift Card" />

              <div style={{ marginTop: "10px" }}>
                <div className="table_search">
                  <TextField
                    style={{ marginBottom: "10px", width: "25%" }}
                    placeholder="Enter gift title..."
                    type="text"
                    onChange={handleFilterChange}
                    value={filterValue}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <SearchIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <TableContainer component={Paper}>
                      <Table
                        className="c_table"
                        size="small"
                        aria-label="a dense table"
                        stickyHeader
                        sx={{ minWidth: 500 }}
                      >
                        <TableHead>
                          <TableRow>
                            <TableCell align="center">Gift ID</TableCell>
                            <TableCell align="center">Title</TableCell>
                            <TableCell align="center">Source</TableCell>
                            <TableCell align="center">Start Date </TableCell>
                            <TableCell align="center">End Date</TableCell>
                            <TableCell align="center">Creative</TableCell>
                            <TableCell align="center">Sort Order</TableCell>
                            {/* <TableCell align="center">Featured</TableCell> */}
                            <TableCell align="center">Active</TableCell>
                            <TableCell align="center">Options</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {rowsToDisplay
                            .slice(
                              page * rowsPerPage,
                              page * rowsPerPage + rowsPerPage
                            )
                            .map((row) => (
                              <TableRow
                                key={row.id}
                                sx={{
                                  "&:last-child td, &:last-child th": {
                                    border: 0,
                                  },
                                }}
                              >
                                <TableCell align="center">{row.id}</TableCell>
                                <TableCell align="center">
                                  {row.gift_title}
                                </TableCell>
                                <TableCell align="center">
                                  {row.description}
                                </TableCell>
                                <TableCell align="center">
                                  {moment
                                    .utc(row.startdate)
                                    .format("YYYY-MM-DD HH:mm")}
                                </TableCell>
                                <TableCell align="center">
                                  {moment
                                    .utc(row.enddate)
                                    .format("YYYY-MM-DD HH:mm")}
                                </TableCell>

                                <TableCell align="center">
                                  <img
                                    // src={`${endPoints.apiBaseUrl}${row.creative}`}
                                    src={
                                      row?.creative.includes("https:")  ?  row.creative : `${DefaultImageBaseurl}${row.creative}`
                                    }
                                    style={{ height: "50px" }}
                                  />
                                </TableCell>
                                <TableCell
                                  align="center"
                                  style={{ width: "20%" }}
                                >
                                  <Form.Control
                                    value={row.sort_order}
                                    // onChange={(e) => setLimit(e.target.value)}
                                  />
                                </TableCell>
                                {/* <TableCell align="center">
                                <Switch

                                  checked={row.isfeatured !== 0}
                                  onChange={() => handleSwitchChange(row, 'isfeatured', row.isfeatured)}
                                />
                              </TableCell> */}
                                <TableCell align="center">
                                  <Switch
                                    checked={row.isactive !== 0}
                                    onChange={() =>
                                      handleSwitchChange(
                                        row,
                                        "isactive",
                                        row.isactive
                                      )
                                    }
                                  />
                                </TableCell>

                                <TableCell align="center">
                                  <EditIcon
                                    onClick={() => {
                                      setShow(true);
                                      setCreateData(true);
                                      setEditData(row);
                                    }}
                                  />
                                  <DeleteIcon
                                    style={{ cursor: "pointer" }}
                                    onClick={() => handleDelete(row)}
                                  />
                                </TableCell>
                              </TableRow>
                            ))}

                          {emptyRows > 0 && (
                            <TableRow style={{ height: 53 * emptyRows }}>
                              <TableCell colSpan={6} />
                            </TableRow>
                          )}
                        </TableBody>
                        <TableFooter>
                          <TableRow>
                            <TablePagination
                              rowsPerPageOptions={[
                                5,
                                10,
                                25,
                                { label: "All", value: -1 },
                              ]}
                              colSpan={12}
                              count={rowsToDisplay.length}
                              rowsPerPage={rowsPerPage}
                              page={page}
                              SelectProps={{
                                inputProps: {
                                  "aria-label": "rows per page",
                                },
                                native: true,
                              }}
                              onPageChange={handleChangePage}
                              onRowsPerPageChange={handleChangeRowsPerPage}
                              ActionsComponent={TablePaginationActions}
                            />
                          </TableRow>
                        </TableFooter>
                      </Table>
                    </TableContainer>
                  </div>
                  <>
                    <Modal
                      show={show}
                      onHide={handleClose}
                      // style={{ marginTop: "10%" }}
                      size="lg"
                      backdrop="static"
                      keyboard={false}
                    >
                      <Modal.Header closeButton>
                        <Modal.Title>Manage Gifts:</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <div className="row">
                          <div className="col-md-8">
                            <Form.Group
                              className="mb-3"
                              controlId="providerName"
                            >
                              <Form.Label>Gift Title </Form.Label>
                              <Form.Control
                                type="text"
                                placeholder="Gift Title "
                                value={giftTitle}
                                onChange={(event) => {
                                  setGiftTitle(event.target.value);
                                }}
                              />
                            </Form.Group>
                          </div>

                          <div className="col-md-4">
                            <Form.Group className="mb-3" controlId="game">
                              <Form.Label>Sage Coin Price </Form.Label>
                              <Form.Control
                                type="number"
                                placeholder="100"
                                value={sagaCoinPrice}
                                onChange={(event) => {
                                  setSagaCoinPrice(event.target.value);
                                }}
                              />
                            </Form.Group>
                          </div>
                          {/* <div className="col-md-4">
                            <Form.Group className="mb-3" controlId="game">
                              <Form.Label>Start Date</Form.Label>
                              <Form.Control
                                type="date"
                                placeholder="Start Date"
                                value={startDate}
                                onChange={(event) => {
                                  setStartDate(event.target.value);
                                }}
                              />
                            </Form.Group>
                          </div>
                          <div className="col-md-4">
                            <Form.Group className="mb-3" controlId="game">
                              <Form.Label>Start Time</Form.Label>
                              <Form.Control
                                type="time"
                                placeholder="Start Time"
                                value={startTime}
                                onChange={(event) => {
                                  setStartTime(event.target.value);
                                }}
                              />
                            </Form.Group>
                          </div> */}
                              <div className="col-md-4">
                            <Form.Group className="mb-3" controlId="game">
                              <Form.Label> Campaign Name </Form.Label>
                              <Form.Control
                                type="text"
                                placeholder="campaign Name "
                                value={campaignName} // chnage
                                onChange={(event) => {
                                  setCampaignName(event.target.value);
                                }}
                              />
                            </Form.Group>
                          </div>
                          <div className="col-md-4">
                            <Form.Group className="mb-3" controlId="game">
                              <Form.Label>Campaign Id </Form.Label>
                              <Form.Control
                                type="text"
                                placeholder="Campaign Id"
                                value={campaignId}
                                onChange={(event) => {
                                  setCampaignId(event.target.value);
                                }}
                              />
                            </Form.Group>
                          </div>
                          <div className="col-md-4"></div>
                            <div className="col-md-4">
                            <Form.Group className="mb-3" controlId="game">
                              <Form.Label> Country Name</Form.Label>
                              <Form.Control
                                type="text"
                                placeholder="Country Name"
                                value={countryName} // chnage
                                onChange={(event) => {
                                  setCountryName(event.target.value);
                                }}
                              />
                            </Form.Group>
                          </div>
                          <div className="col-md-4">
                            <Form.Group className="mb-3" controlId="game">
                              <Form.Label>Currency  Code </Form.Label>
                              <Form.Control
                                type="text"
                                placeholder="Currency Code"
                                value={currencyCode}
                                onChange={(event) => {
                                  setCurrencyCode(event.target.value);
                                }}
                              />
                            </Form.Group>
                          </div>
                          <div className="col-md-4">
                            <Form.Group className="mb-3" controlId="game">
                              <Form.Label>Upload Creative </Form.Label>
                              <Form.Label
                                className="text-danger"
                                style={{ fontSize: "12px", fontWeight: "800" }}
                              >
                                Image should be (210*140)
                              </Form.Label>

                              <Form.Control
                                type="file"
                                placeholder="Upload Creative"
                                onChange={handleFileChange}
                              />
                            </Form.Group>
                          </div>
                          {/* <div className="col-md-4">
                            <Form.Group className="mb-3" controlId="game">
                              <Form.Label>End Date</Form.Label>
                              <Form.Control
                                type="date"
                                placeholder="End Date"
                                value={endDate}
                                onChange={(event) => {
                                  setEndDate(event.target.value);
                                }}
                              />
                            </Form.Group>
                          </div>
                          <div className="col-md-4">
                            <Form.Group className="mb-3" controlId="game">
                              <Form.Label>End Time</Form.Label>
                              <Form.Control
                                type="time"
                                placeholder="End Time"
                                value={endTime}
                                onChange={(event) => {
                                  setEndTime(event.target.value);
                                }}
                              />
                            </Form.Group>
                          </div> */}
                             <div className="col-md-8">
                            <Form.Group className="mb-3" controlId="game">
                              <Form.Label>Redemption Instructions </Form.Label>
                              <Form.Control
                                as="textarea"
                                // disabled={true} value={
                                //   `get 10% Cahback on all your play this week paid back to tour saga coins account on Tuesday.You can play knowing
                                //   that even if you lose there is still some cash heading yor way.`
                                // }
                                value={giftCopy}
                                onChange={(event) => {
                                  setgiftCopy(event.target.value);
                                }}
                              />
                            </Form.Group>
                          </div>
                          <div className="col-md-4">
                            {showcreative && (
                              <div>
                                <img
                                  src={showcreative}
                                  alt="Selected"
                                  style={{ maxWidth: "100px" }}
                                />
                              </div>
                            )}
                          </div>
                        
                        
                      

                          <div className="col-md-8">
                            <Form.Group className="mb-3" controlId="game">
                              <Form.Label>Terms and Conditions :</Form.Label>
                              <Form.Control
                                as="textarea"
                                // disabled={true}
                                //    value={
                                //   `1. You must be a member and playing with saga coins to qualify.
                                //    2. Spin Saga Casino will pay you 10% on all cumulative losses over the promotional period....`
                                // }
                                value={termConditions}
                                onChange={(event) => {
                                  setTermConditions(event.target.value);
                                }}
                              />
                            </Form.Group>
                          </div>
                          <div className="col-md-4"></div>

                          <div className="col-md-4">
                            <Form.Group
                              className="mb-3"
                              controlId="providerName"
                            >
                              <Form.Label>Menu Sort order</Form.Label>
                              <Form.Control
                                type="number"
                                placeholder="100"
                                value={menuSort}
                                onChange={(event) => {
                                  setMenuSort(event.target.value);
                                }}
                              />
                            </Form.Group>
                          </div>
                          <div className="col-md-4" style={{ marginTop: "5%" }}>
                            <Form.Check
                              inline
                              label="Active"
                              name="isCheckedActive"
                              type={"checkbox"}
                              id={`inline-${"checkbox"}-1`}
                              onChange={handleCheckboxChange}
                              checked={checkboxes.isCheckedActive}
                            />
                            {/* <Form.Check
                              inline
                              label="Featured"
                              name="isCheckedFeatured"
                              type={"checkbox"}
                              id={`inline-${"checkbox"}-2`}
                              onChange={handleCheckboxChange}
                              checked={checkboxes.isCheckedFeatured}
                            /> */}
                          </div>
                          <div className="col-md-4"></div>
                        </div>
                      </Modal.Body>
                      <Modal.Footer>
                        <Button
                          onClick={handleOk}
                          style={{
                            background: "#04631e",
                            borderColor: "#04631e",
                          }}
                        >
                          Apply
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  </>
                </div>
              </div>
              {/* <div
                style={{
                  display: "flex",
                  justifyContent: "end",
                  marginTop: "20px",
                }}
              >
                <Button
                  variant="primary"
                  style={{ background: "#04631e", borderColor: "#04631e" }}
                  onClick={() => {
                    setShow(true);
                    setEditData({});
                    setCreateData(true);
                  }}
                >
                  Add New Gift
                </Button>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Redemption;
